import React, { Fragment, useEffect, useState } from "react";
import { any, func, bool, object, arrayOf, shape, string } from "prop-types";
import { connect } from "react-redux";
import ReadingStatus from "../ReadingListDownload/reading_status";
import { markDocumentReadPecan } from "../../redux/actions";
import { getGateForm } from "../../api/profileApi";
import OnboardingArea from "../../common/OnboardingSectionCreator";
import { Button } from "../../common";
import Spinner from "../../common/Spinner";
import * as style from "../ReadingListDownload/styles.module.scss";
import * as styles from "./styles.scss";
import { submitGateForm } from "../../redux/actions/gateActions";

const GateOnboarding = ({
  appData,
  gateReadingListLoading,
  readingList,
  markDocumentReadFunc,
  submitGateFormsFunc,
}) => {
  const { gateOnboarding } = { ...{ gateOnboarding: {} }, ...appData };

  const [loading, setLoading] = useState(false);

  const submitted = gateOnboarding && gateOnboarding.submitted;

  useEffect(() => {
    setLoading(false);
  }, [submitted]);

  const formsListWithStatus = [
    {
      status: gateOnboarding.application
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "Application Form",
      url: `/profile/edit/gate-group-onboarding/application`,
    },
    {
      status: gateOnboarding.workhistory
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "5 Year Work History",
      url: `/profile/edit/gate-group-onboarding/work-history`,
    },
    {
      status: gateOnboarding.referenceeducation
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "Reference & Education",
      url: `/profile/edit/gate-group-onboarding/reference-education`,
    },
    {
      status: gateOnboarding.declaration
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "Declaration",
      url: `/profile/edit/gate-group-onboarding/declaration`,
    },
  ];

  const canSubmit = formsListWithStatus.every(
    (doc) => doc.status === ReadingStatus.Done
  );

  const handleSubmit = () => {
    setLoading(true);
    submitGateFormsFunc(appData.gateOnboarding);
  };

  const triggerDownload = () => {
    setLoading(true);
    getGateForm().then((response) => {
      // todo
      const link = document.createElement("a");
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `Gate_Group.pdf`;
      link.click();
      setLoading(false);
    });
  };

  const leftColumnComponents = [
    {
      title: "Gate Group Forms",
      formsListWithStatus,
      submitted,
    },
  ];

  const submitRow = () => {
    return (
      <div className={style.buttonContainer}>
        {!submitted ? (
          <Fragment>
            <div className={styles.submitButtonDesktop}>
              Please click on the Submit button for your forms to be sent to HR
              GO.
            </div>
            <Button
              classes={`btn btn-primary ${style.buttonSubmit}`}
              onClick={handleSubmit}
              disabled={canSubmit && !loading ? "" : "disabled"}
            >
              {loading ? (
                <Fragment>
                  Submit <Spinner />
                </Fragment>
              ) : (
                "Submit"
              )}
            </Button>
          </Fragment>
        ) : (
          <button
            className="btn btn-primary"
            onClick={triggerDownload}
            disabled={loading ? "disabled" : ""}
          >
            {loading ? (
              <Fragment>
                Download Form <Spinner />
              </Fragment>
            ) : (
              "Download Form"
            )}
          </button>
        )}
      </div>
    );
  };

  return (
    <OnboardingArea
      title="Gate Group Onboarding"
      leftColumnComponents={leftColumnComponents}
      rightColumnComponents={[]}
      leftSubmit={submitRow}
      hasDBS={true}
      dbsURL="https://forms.office.com/Pages/ResponsePage.aspx?id=bF43RFTuvUGKgS0U9GKUztDCA2HJiIpHsdJGOi34cPhUNzIxS0lXRDNQQzRNSlY5OEpPNEJFSFE0SiQlQCN0PWcu"
    />
  );
};

GateOnboarding.propTypes = {
  appData: any,
  submitDnataFormFunc: func,
  gateReadingListLoading: bool,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  gateOnboarding: object,
  markDocumentReadFunc: func.isRequired,
  submitGateFormsFunc: func.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  gateOnboarding: state.core.app.gateOnboarding,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadPecan,
  submitGateFormsFunc: submitGateForm,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(GateOnboarding);
